import React from 'react';
import { type ViTriKho, ViTriKhoInput } from '@/types/schemas/vi-tri-kho.type';
import { ConfirmationDialog, ErpDataTableV2 } from '@/components/custom/erp';
import { ActionBar, WarehouseLocationDialog } from './components';
import { getDataTableColumns } from './cols-definition';
import { usePathname, useRouter } from '@/routing';
import { useCRUD } from '@/hooks/queries';
import { QUERY_KEYS } from '@/constants';
import { useFormState } from '@/hooks';

export default function ViTriKhoHang() {
  const router = useRouter();
  const pathName = usePathname();

  const { addItem, updateItem, deleteItem, refreshData, isLoading, data } = useCRUD<ViTriKho, ViTriKhoInput>({
    endpoint: QUERY_KEYS.VI_TRI_KHO_HANG
  });

  const {
    showForm,
    showDelete,
    selectedObj,
    selectedRowIndex,
    formMode: mode,
    isCopyMode,

    handleCloseForm,
    handleCloseDelete,
    handleAddClick,
    handleEditClick,
    handleViewClick,
    handleDeleteClick,
    handleCopyClick,
    handleRowClick,
    clearSelection
  } = useFormState<ViTriKho>();

  const handleTabChange = (tabPath: string) => {
    if (tabPath === pathName) return;
    router.push(`/danh-muc/vat-tu-san-pham-va-kho/${tabPath}`);
  };

  const tables = [
    {
      name: 'Vật tư, sản phẩm',
      rows: [],
      columns: [],
      value: 0
    },
    {
      name: 'Lô hàng',
      rows: [],
      columns: [],
      value: 1
    },
    {
      name: 'Kho hàng',
      rows: [],
      columns: [],
      value: 2
    },
    {
      name: 'Vị trí kho hàng',
      rows: data,
      columns: getDataTableColumns(),
      value: 3
    }
  ];

  const handleSubmit = async (data: ViTriKhoInput) => {
    try {
      if (mode === 'add') {
        await addItem(data);
      } else if (mode === 'edit' && selectedObj) {
        await updateItem(selectedObj.uuid, data);
      }
      handleCloseForm();
      clearSelection();
    } catch (err: unknown) {
      return;
    }
  };

  return (
    <div className='flex h-full min-h-screen w-full min-w-0 max-w-full flex-col lg:overflow-hidden'>
      {showForm && (
        <WarehouseLocationDialog
          mode={mode}
          open={showForm}
          onClose={handleCloseForm}
          onAddButtonClick={handleAddClick}
          onEditButtonClick={handleEditClick}
          onCopyButtonClick={handleCopyClick}
          onWatchButtonClick={handleViewClick}
          onDeleteButtonClick={handleDeleteClick}
          onSubmit={handleSubmit}
          initialData={mode === 'add' && !isCopyMode ? undefined : selectedObj}
        />
      )}

      <div className='w-full'>
        <ActionBar
          onAddIconClick={handleAddClick}
          onEditIconClick={handleEditClick}
          onDeleteIconClick={handleDeleteClick}
          onCopyIconClick={handleCopyClick}
          onWatchIconClick={handleViewClick}
          onRefreshClick={refreshData}
        />

        <ErpDataTableV2
          tables={tables}
          selectedRowId={selectedRowIndex || undefined}
          onRowClick={handleRowClick}
          defaultTabIndex={3}
          onTabChange={(_, value: number) => {
            const tabPaths = ['vat-tu-san-pham', 'lo-hang', 'kho-hang', 'vi-tri-kho-hang'];
            handleTabChange(tabPaths[value]);
          }}
          loading={isLoading}
        />
      </div>

      {showDelete && (
        <ConfirmationDialog
          open={showDelete}
          onClose={handleCloseDelete}
          onConfirm={() => {
            deleteItem(selectedObj!.uuid);
            handleCloseDelete();
            clearSelection();
            handleCloseForm();
          }}
        />
      )}
    </div>
  );
}
